<div class="aero-input">
  <div *ngIf="input.invalid && (input.dirty || input.touched)"
     class="right">
    <span class="error-icon-tooltip right">
      <i class="fa fa-exclamation-circle error-icon"
         aria-hidden="true">
      </i>
    </span>
  </div>
  <!-- ***Important*** needed and only used to show icon for custom error messages, handled by our aero-form. -->
  <div style="display: none"
     class="right">
    <span class="error-icon-tooltip right">
      <i class="fa fa-exclamation-circle error-icon"
         aria-hidden="true">
      </i>
    </span>
  </div>
  <div class="bulb-input-label-wrapper">
    <label *ngIf="label"
         [for]="id"
         class="bulb-input-label-wrapper"
         [ngClass]="{'bulb-required': required}"
    >
      {{ label }}
    </label>
    <span *ngIf="hintMessage"
        [ngClass]="{'bulb-hint-error-message': input.invalid && (input.dirty || input.touched)}"
        class="bulb-hint-message">
      {{hintMessage}}
    </span>
  </div>
  <input pInputText
       #input="ngModel"
       [type]="type"
       [id]="id"
       [attr.aria-label]="ariaLabel"
       [required]="required"
       [placeholder]="placeholder"
       [disabled]="disabled"
       [readonly]="readonly"
       [name]="name"
       [autocomplete]="autocomplete"
       [attr.autocorrect]="autocorrect"
       [(ngModel)]="inputValue"
       (blur)="onBlur()"
       (ngModelChange)="updateChanges()"
       [maxlength]="maxlength"
       [minlength]="minlength"
       [email]="email"
       [pattern]="pattern"
       [bulbAutofocus]="autofocus"/>
  <!-- content the developer passed in to show up to the right fo the input field. -->
  <ng-content></ng-content>
  <div class="bulb-error-wrapper">
    <span *ngIf="input.invalid && ( input.dirty || input.touched )"
        class="bulb-bottom-error-msg">
      {{ errorMessage }}
    </span>
  </div>
  <!-- ***Important*** needed and only used to show error meesage for custom error code, handled by our aero-form. -->
  <div class="bulb-error-wrapper custom-code-error-message" style="display: none">
    <!-- Error message will show up here dynamically. -->
  </div>

</div>
